export function common() {
  const header = document.getElementById("js-header");

  const headerScroll = () => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 1 && window.innerWidth > 768) {
        header.classList.add("is-scroll");
      } else {
        header.classList.remove("is-scroll");
      }
    });
  };

  headerScroll();

  /**
   * スクロールで画像を切り替える
   */
  // 画面をスクロールして.js-change-image が画面の半分に来たら、data-numを取得する
  const changeImage = () => {
    const changeImage = document.querySelectorAll(".js-change-image");
    if (changeImage.length === 0) {
      return;
    }
    const changeImageArray = Array.prototype.slice.call(changeImage);
    const interviewBlockImages = document.querySelectorAll(`.js-scroll-images img`);
    const interviewBlockImageArray = Array.prototype.slice.call(interviewBlockImages);

    changeImageArray.forEach((element) => {
      window.addEventListener("scroll", () => {
        const rect = element.getBoundingClientRect();
        const top = rect.top;
        const check = window.innerHeight * 0.75;

        interviewBlockImageArray.forEach((image) => {
          const num = element.getAttribute("data-num");
          const changeImage = document.querySelectorAll(`.js-scroll-image${num}`);

          if (changeImage.length > 0 && top < check) {
            // まず画像のis-showクラスを削除
            interviewBlockImageArray.forEach((image) => {
              image.classList.remove("is-show");
            });
            // その後、該当の画像にis-showクラスを付与
            changeImage.forEach((image) => {
              image.classList.add("is-show");
            });
          }
        });
      });
    });
  };

  changeImage();
}
